import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {Router} from '@angular/router';
import {LocalStorageService} from './local-storage.service';
import {ToastMessagesService} from './toast-messages.service';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    public directionTypes = [{id: 1, type: 'start start center', label: 'Αρχή'}, {
        id: 2,
        type: 'center start center',
        label: 'Κέντρο'
    }, {id: 3, type: 'end start center', label: 'Τέλος'}];
    public returnUrl = '';
    public sectionTypes = [{id: 1, type: 'text', label: 'Κείμενο'}, {id: 2, type: 'checkbox', label: 'Πολλαπλής επιλογής'}, {
        id: 3,
        type: 'radio',
        label: 'Απλής επιλογής'
    }, {id: 4, type: 'toggle', label: 'ΝΑΙ/ΟΧΙ'}, {id: 5, type: 'select', label: 'Dropdown'},
        {id: 6, type: 'textarea', label: 'Περιοχή κειμένου'}, {id: 7, type: 'label', label: 'Ετικέτα'}];

    constructor(public router: Router, public httpClient: HttpClient, public localStorage: LocalStorageService,
                public toastMessagesService: ToastMessagesService, private localStorageService: LocalStorageService) {
    }

    public setPaginatorTexts(paginator: MatPaginator): MatPaginator {
        paginator._intl.itemsPerPageLabel = 'Εγγραφές Ανά Σελίδα';
        paginator._intl.firstPageLabel = 'Πρώτη Σελίδα';
        paginator._intl.lastPageLabel = 'Τελευταία Σελίδα';
        paginator._intl.nextPageLabel = 'Επόμενη Σελίδα';
        paginator._intl.previousPageLabel = 'Προηγούμενη Σελίδα';

        paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            if (length === 0 || pageSize === 0) {
                return `0 από ${length}`;
            }

            length = Math.max(length, 0);

            const startIndex = page * pageSize;

            const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

            return `${startIndex + 1} - ${endIndex} από ${length}`;
        };

        return paginator;
    }

    async redirectToLogin() {
        console.log('redirecting');
        this.localStorage.clear(`token`);
        await this.router.navigate(['login']);
    }

    getList(model: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${model}`).subscribe((response: any) => {
                resolve({status: 200, object: response});
            }, async (error) => {
                if (error.status === 401) {
                    this.toastMessagesService.toastMessages(`Εληξε η περίοδος της σύνδεσής σας. Παρακαλούμε συνδεθείτε ξανά`);
                    await this.redirectToLogin();
                } else {
                    reject({status: error.status, error, message: error.message});
                }
            });
        });
    }

    insertItem(model: string, insertModel: any) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(`${model}`, {insertModel}).subscribe((response: any) => {
                resolve({status: 200, object: response});
            }, async (error) => {
                if (error.status === 401) {
                    this.toastMessagesService.toastMessages(`Εληξε η περίοδος της σύνδεσής σας. Παρακαλούμε συνδεθείτε ξανά`);
                    await this.redirectToLogin();
                } else {
                    console.log(error);
                    reject({status: error.status, message: error.message, serverMessage: error.error.message});
                }
            });
        });
    }

    updateItem(model: string, insertModel: any) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(`${model}`, {insertModel}).subscribe((response: any) => {
                resolve({status: 200, object: response});
            }, error => reject({status: error.status, message: error.message}));
        });
    }

    formatData(data) {
        const model = {};
        for (const item of data) {
            model[item.key] = item.value;
        }

        return model;
    }

    formatColumns(data) {
        const columns = [];
        for (const item of data) {
            columns.push({key: item.key, label: item.key});
        }
        return columns;
    }

    async deleteItem(model: string) {
        return new Promise((resolve, reject) => {
            this.httpClient.delete(`${model}`).subscribe((response: any) => {
                resolve({status: 200, object: response});
            }, error => reject({status: error.status, message: error.message}));
        });
    }

    public postDataNoPromise = (endpoint: string, model: any) => {
        return this.httpClient.post(`${endpoint}`, {insertModel: model});
    }

    public postRequest = async (endpoint: string, model: any) => {
        return new Promise((resolve, reject) => {
            this.httpClient.post(`${endpoint}`, {insertModel: model}).subscribe(data => {
                resolve(data);
            }, error => reject(error));
        });
    }

    public getDataNoPromise = (model: string) => {
        return this.httpClient.get(`${model}`);
    }

    blobToImage = (blob) => {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
            };
        });
    }

    checkForEscapeCharacter(value: string) {
        const escapeCharacters = ['\\', '\'', '\"'];

        for (const escapeChar of escapeCharacters) {
            if (value.includes(escapeChar)) {
               return true;
            }
        }

        return false;
    }

    public getButtonColor(status: number) {
        if (status === 1) {
            return 'green';
        } else if (status === -1) {
            return '#fcb602';
        } else {
            return '#df1326';
        }
    }

    public getAffirmationPublishedColor(isPublished) {
        if (isPublished === 1) {
            return 'green';
        } else if (isPublished === -1) {
            return '#fcb602';
        } else {
            return '#df1326';
        }
    }

    public getAffirmationButtonColor(status: number) {
        if (status === 1) {
            return 'green';
        } else if (status === 2) {
            return '#df1326';
        } else {
            return '#fcb602';
        }
    }

    public isEmpty(str) {
        return (!str || 0 === str.length);
    }

    async logout() {
        this.localStorageService.clear('user');
        this.localStorageService.clear('token');
        await this.router.navigate(['login']);
    }

    public uploadImage(model: string, image: File) {
        const formData = new FormData();

        formData.append('image', image);

        return new Promise((resolve, reject) => {
            this.httpClient.post(`${model}`, formData).subscribe((response: any) => {
                resolve({status: 200, object: response});
            }, error => reject({status: error.status, message: error.message}));
        });
    }


    public validateData(child: any) {
        Object.keys(child).forEach((key, index) => {
            child[key] = child[key] ? child[key] : '-';
        });
    }

  public base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, '');
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

}
